import axiosInstance from "./AxiosInstance";

const checkPONumber = async (poNumber) => {
  try {
    const response = await axiosInstance.get('/po', {
      params: { poNumber }, 
    });
    return response.data; 
  } catch (error) {
    console.error("Error checking PO number:", error);
    throw new Error("PO number not found"); 
  }
};

export default checkPONumber;
